// Traduce errores técnicos a mensajes amigables para el usuario
export function translateError(err) {
  const msg = err?.message || err?.code || String(err);

  // Firebase Auth
  if (msg.includes('auth/invalid-credential') || msg.includes('auth/wrong-password') || msg.includes('auth/user-not-found'))
    return 'Cédula o contraseña incorrecta. Verifica e intenta de nuevo.';
  if (msg.includes('auth/too-many-requests'))
    return 'Demasiados intentos fallidos. Espera unos segundos y vuelve a intentar.';
  if (msg.includes('auth/email-already-in-use'))
    return 'Ya existe un usuario con esta cédula.';
  if (msg.includes('auth/weak-password'))
    return 'La contraseña es muy débil. Usa al menos 6 caracteres.';
  if (msg.includes('auth/requires-recent-login'))
    return 'Por seguridad, vuelve a iniciar sesión antes de cambiar la contraseña.';
  if (msg.includes('auth/invalid-email'))
    return 'El formato del correo no es válido.';
  if (msg.includes('auth/network-request-failed'))
    return 'Sin conexión a internet. Verifica tu red.';

  // Firestore / Permisos
  if (msg.includes('permission-denied') || msg.includes('does not have permission'))
    return 'No tienes permiso para realizar esta acción. Contacta al administrador.';
  if (msg.includes('not-found') || msg.includes('No encontrado'))
    return 'El recurso solicitado no existe o fue eliminado.';
  if (msg.includes('already-exists'))
    return 'Este registro ya existe en el sistema.';

  // Storage
  if (msg.includes('storage/unauthorized'))
    return 'No tienes permiso para subir archivos.';
  if (msg.includes('storage/canceled'))
    return 'La subida fue cancelada.';
  if (msg.includes('storage/unknown'))
    return 'Error al subir el archivo. Intenta de nuevo.';

  // Mensajes personalizados del sistema (ya en español)
  if (msg.includes('QR inválido') || msg.includes('QR no encontrado')
    || msg.includes('QR ya fue utilizado') || msg.includes('QR ha caducado')
    || msg.includes('No autenticado') || msg.includes('Usuario no encontrado')
    || msg.includes('Ya existe un usuario'))
    return msg;

  // Cámara
  if (msg.includes('NotAllowedError') || msg.includes('Permission denied'))
    return 'Permiso de cámara denegado. Actívalo en la configuración del navegador.';
  if (msg.includes('NotFoundError') || msg.includes('No se pudo acceder a la cámara'))
    return 'No se encontró una cámara disponible.';
  if (msg.includes('NotReadableError'))
    return 'La cámara está en uso por otra aplicación.';

  // Errores de red
  if (msg.includes('Failed to fetch') || msg.includes('NetworkError'))
    return 'Error de conexión. Verifica tu internet e intenta de nuevo.';

  // Si no hay traducción, devolver mensaje genérico
  return 'Ocurrió un error inesperado. Intenta de nuevo más tarde.';
}